export interface IUserKeyParams {
  user: string;
  country: string;
}

export const userKeys = {
  root: (params: IUserKeyParams) =>
    ['user', params.user, params.country] as const,
  lockedApplications: (params: IUserKeyParams) =>
    [...userKeys.root(params), 'applications locked by'] as const,
  assignedApplications: (params: IUserKeyParams) =>
    [...userKeys.root(params), 'assigned applications'] as const,
  assignee: (params: IUserKeyParams) =>
    [...userKeys.root(params), 'assignee'] as const,
  heartbeat: (params: IUserKeyParams) =>
    [...userKeys.root(params), 'heartbeat'] as const,
  recentlyOpenedApplications: (params: IUserKeyParams) =>
    [...userKeys.root(params), 'recently opened applications'] as const,
};

export function parseUserKey<T extends keyof typeof userKeys>(
  queryKey: ReturnType<(typeof userKeys)[T]>
): IUserKeyParams {
  const [, user, country] = queryKey;

  return { user, country };
}
